import axios from 'axios'

import { store } from '../redux/store/index'
import { logout } from '../redux/slices/AuthSlice'
import { REACT_APP_BACKEND_URL_TEST } from '../Config'

const Axios = axios.create({
  baseURL: REACT_APP_BACKEND_URL_TEST,
  headers: {
    Accept: `application/json`,
  },
})

Axios.interceptors.request.use(
  config => {
    const state = store.getState()
    const token = state?.auth?.token
    config.headers['Accept-Language'] =
      localStorage.getItem('i18nextLng') || 'en'
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },

  error => {
    return Promise.reject(error)
  }
)

Axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      store.dispatch(logout())
    }
    return Promise.reject(error)
  }
)

export default Axios
